import { useMemo } from 'react';
import http from 'hub-http/clients/apiClient';
import { useQuery, registerQuery } from 'data-fetching-client';
const fetchContentUsageLimit = ({
  contentObjectType
}) => {
  return http.get(`content-management/core/v1/app/${contentObjectType}/usage`);
};
const ContentUsageLimitQuery = registerQuery({
  fieldName: 'contentUsageLimit',
  fetcher: fetchContentUsageLimit,
  args: ['contentObjectType']
});
const useFetchContentUsageLimit = ({
  contentObjectType,
  skip
}) => {
  const {
    data,
    loading,
    error,
    called
  } = useQuery(ContentUsageLimitQuery, {
    skip: skip || !contentObjectType,
    variables: {
      contentObjectType: contentObjectType
    }
  });
  return useMemo(() => ({
    contentUsageLimit: data === null || data === void 0 ? void 0 : data.contentUsageLimit,
    loading,
    error,
    called
  }), [data, error, loading, called]);
};
export default useFetchContentUsageLimit;